// components/ContactCommentList.tsx

import { trpc } from '@web/lib/trpc';
import { CommentCard } from './comment-card';
import { Plus } from 'lucide-react';
import { Button } from '@web/components/ui/button';

type ContactCommentListProps = {
  contactId: string;
  setActiveCommentId: (commentId: string | null) => void,
};

export function ContactCommentList({ contactId, setActiveCommentId }: ContactCommentListProps) {
  
  const { mutateAsync: createCommentOnRecord } =
    trpc.comment.createCommentOnRecord.useMutation();

  const {
    data: comments,
    isLoading,
    isError,
    error,
  } = trpc.comment.listAllCommentsOnRecord.useQuery({
    parentRecordId: contactId,
    parentTable: 'contacts',
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-10">
        {/* You can replace this with a Radix UI spinner or any loading indicator */}
        <div className="loader h-12 w-12 rounded-full border-4 border-t-4 border-gray-200 ease-linear"></div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="py-10 text-center text-red-500">
        <p>Failed to load comments: {error.message}</p>
      </div>
    );
  }

  const handleCreateComment = async () => {
    const newCommentId = await createCommentOnRecord({
      parentRecordId: contactId,
      parentTable: 'contacts',
      content: '',
    });

    setActiveCommentId(newCommentId);
  };

  return (
    <div className="">
      <Button
        onClick={() => {
          void handleCreateComment();
        }}
        className="w-full gap-2"
      >
        <Plus />
        Add Comment
      </Button>

      {comments?.length ? (
        <ul className="mt-5 flex flex-col gap-3">
          {comments.map((comment) => (
            <CommentCard
              key={comment.id}
              comment={{
                ...comment,
                createdBy: {
                  id: comment.createdBy.id,
                  name: `${comment.createdBy.firstName} ${comment.createdBy.lastName ?? ''}`.trim(),
                  avatarUrl: undefined,
                },
              }}
              setActiveCommentId={setActiveCommentId}
            />
          ))}
        </ul>
      ) : (
        <div className="py-10 text-center text-gray-500">
          <p>No comments available for this contact.</p>
        </div>
      )}
    </div>
  );
}
